import { atom } from "jotai";

export const notificationAtom = atom({ data: [] });
